import ForwardArrow from "@mui/icons-material/ArrowForwardIosRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { toPascalCase } from "../../../utils/functions";

const Breadcrump = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathItems = location.pathname.split("/").filter(Boolean);
  const breadcrumbItems = pathItems.map((i, index) => ({
    label: toPascalCase(i),
    url: `/${pathItems.slice(0, index + 1).join("/")}`,
  }));

  const redirectToPath = (url) => {
    if (url) navigate(url);
  };

  return (
    <div className="breadcrumb">
      {breadcrumbItems.map((item, index) => {
        return (
          <>
            <span
              className="breadcrumb-item"
              onClick={() => {
                if (index !== pathItems.length - 1) redirectToPath(item.url);
              }}
            >
              {item.label}
            </span>
            {index !== pathItems.length - 1 ? (
              <span className="delimeter">
                <ForwardArrow fontSize="14px" />
              </span>
            ) : (
              <></>
            )}
          </>
        );
      })}

      {/* <span className="delimeter">
        <ForwardArrow fontSize="14px" />
      </span>
      <span className="breadcrumb-item">YouTube</span> */}
    </div>
  );
};

export default Breadcrump;
